<template>
  <div class="lng-switcher dropdown">
    <button class="btn btn-sm btn-transparent btn-contrast lng-switcher__toggle dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            :disabled="isDisabled"
            aria-expanded="true" style="text-transform: uppercase;">
      {{ currentLocale }} <span class="caret"></span>
    </button>
    <ul class="lng-switcher__menu dropdown-menu">
      <template v-for="locale in locales">
        <li>
          <button class="btn-link" :disabled="isDisabled" href="#" @click.prevent="changeLocale(locale)">
            {{ locale.toUpperCase() }}
          </button>
        </li>
      </template>
    </ul>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
//import {ApplicationLocale} from '@/models/ApplicationLocale';
//const UrlParser = require('url-parse');
import UrlParse from 'url-parse';
import {Prop, Component} from "vue-property-decorator";

@Component({
  name: 'LegacyHeaderLangSwitcher',
  // methods: {
  //   changeLocale(locale: string) {
  //     this.$i18n.locale = locale;
  //     //ApplicationLocale.getInstance().locale = locale;
  //     this.$emit('change', locale);
  //   },
  // },
  // computed: {
  //   currentLocale(): string {
  //     return this.$i18n.locale;
  //   },
  // },
})
export default class LegacyHeaderLangSwitcher extends Vue {
  @Prop({default: true})
  redirect: boolean

  @Prop({default: () => ['en', 'ru']})
  locales: string[]

  @Prop({default: 'en'})
  defaultLocale: string

  @Prop({default: false})
  disabled: boolean

  get isDisabled(): boolean {
    return this.disabled || (this.locales.length <= 1);
  }

  isLocaleAllowed(locale: string): boolean {
    return this.locales.includes(locale);
  }

  changeLocale(locale: string) {
    if (!this.isLocaleAllowed(locale)) {
      return;
    }

    this.$i18n.locale = locale;
    // ApplicationLocale.getInstance().locale = locale;
    const URL = UrlParse(window.location.href, true);
    URL.query['lang'] = locale;
    this.$emit('change', locale);
    if (this.redirect)
      window.location.href = URL.toString();
  }

  get currentLocale(): string {
    return this.$i18n.locale;
  }
}
</script>

<style scoped>

</style>
